module.exports = "/images/vu.svg?011c7c535fffcf78ba4f256ed7459ea1";